import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const propTypes = {
  children: PropTypes.node.isRequired,
  routesToRender: PropTypes.arrayOf(PropTypes.string).isRequired,
  bannerVersion: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  backgroundImage: PropTypes.string
};

const TopBanner = ({
  children,
  routesToRender,
  bannerVersion,
  backgroundImage
}) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentPath = location.pathname;
    const shouldShowOnRoute = routesToRender.some(
      route => currentPath === route || currentPath.startsWith(route)
    );

    if (!shouldShowOnRoute) {
      setIsVisible(false);
      return;
    }
    const dismissedVersion = localStorage.getItem('banner_version_dismissed');
    const currentBannerVersion = String(bannerVersion);

    if (!dismissedVersion) {
      setIsVisible(true);
    } else {
      const dismissedVersionNum = parseFloat(dismissedVersion);
      const currentVersionNum = parseFloat(currentBannerVersion);

      if (dismissedVersionNum < currentVersionNum) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }
  }, [location.pathname, routesToRender, bannerVersion]);

  const handleClose = () => {
    localStorage.setItem('banner_version_dismissed', String(bannerVersion));
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  const style = backgroundImage
    ? { backgroundImage: `url(${backgroundImage})` }
    : {};

  return (
    <div className="top-banner">
      <button
        className="top-banner__close-btn"
        onClick={handleClose}
        aria-label="Close banner"
        type="button"
      >
        <i className="fal fa-times" />
      </button>
      <div className="top-banner__content" style={style}>
        {children}
      </div>
    </div>
  );
};

TopBanner.propTypes = propTypes;

export default TopBanner;
